import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, NavLink, useParams } from "react-router-dom";
import profileImage from "../../assets/images/profile/IMG.png";
import vector from "../../assets/images/profile/Vector.png";
import facebook from "../../assets/images/profile/Vector (1).png";
import linkedIn from "../../assets/images/profile/Vector (3).png";
import github from "../../assets/images/profile/mdi_github.png";
import pintrest from "../../assets/images/profile/Vector (4).png";
import insta from "../../assets/images/profile/Vector (5).png";
import youtube from "../../assets/images/profile/Vector (6).png";
import Pdf from "../../assets/images/profile/pdf.png";
import Client from "../../assets/images/profile/IMG (1).png";
import AppliedSec from "../AppliedJobs/AppliedSec";
import axios from "../../API/axios";

const UserResume = () => {

  const { cnddtUID } = useParams();
  const [userData, setUserData] = useState([]);

  const getUserDetail = () => {
    axios
      .get(`/Candidate/GetProfile?UID=${cnddtUID}`)
      .then((response) => {
        const res = response.data.responseData;
        setUserData(res);
        console.log("GetProfile", res);
        
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.log(error);
        } else {
          console.log(error);
        }
      });
  };


  useEffect(() => {
    getUserDetail();
  }, []);



  return (
    <>
      <div className="container">
        <div className="profile-resume-main-container">
          <div className="profile-resume-heading-cont d-flex align-items-center p-4">
            <div className="profile-resume-empty-cont me-2"></div>
            <h2>Overview</h2>
          </div>

          <div className="profile-resume-userinfo mb-3">
            <div className="row p-4">
              <div className="col-md-2">
                <div className="profile-resume-image">
                  <img src={userData.profileImage} alt="" srcset="" />
                </div>
              </div>
              <div className="col-md-8">
                <div className="profile-resume-designation f-14 f-600">
                  {/* Graphic Designer */}
                </div>
                <div className="d-flex align-items-center mb-3 Main-resume-username">
                  <div className="profile-resume-username me-2">
                    {userData.firstName} {userData.lastName}
                  </div>
                  {/* <div className="profile-resume-vector me-2 d-flex justify-content-center align-items-center">
                    <img src={vector} alt="" srcset="" />
                  </div>
                  <div className="profile-resume-available-btn">
                    <Button>Avaialble now</Button>
                  </div> */}
                </div>
                {/* <div className="d-flex Resume-Skills-Country-Mobile">
                  <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                    Blender
                  </div>
                  <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                    Sketch
                  </div>
                  <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                    Adobe XD
                  </div>
                  <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                    Figma
                  </div>
                  <div className="profile-resume-country d-flex align-items-center">
                    <div className="profile-resume-country-icon d-flex me-3 f-18 f-400">
                      <span class="icon-map-pin "></span>
                      {userData.cityName}
                    </div>
                    <div className="profile-resume-country-icon d-flex align-item-center f-18 f-400">
                      <span class="icon-dolar1 me-1"></span>
                      $ 200/ year
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 ">
              {/* <div className="profile-resume-user-details profile-resume-userinfo d-flex flex-column align-items-center">
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between mb-2">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Career Finding
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    UI UX Designer
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Location
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    {userData.cityName}
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Phone Number
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    123 456 7890{" "}
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Email
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    hi.avitex@gmail.com
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Experience time
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    5 Years
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Language
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    English, Vietnamese{" "}
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Age
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    26 Years Old
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline justify-content-between mb-2">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Qualification
                  </div>
                  <div className="profile-resume-user-info-name f-16 f-500">
                    Master Degree
                  </div>
                </div>
                <div className="profile-resume-user-info-list d-flex align-items-baseline mt-2">
                  <div className="profile-resume-user-info-lable f-16 f-400">
                    Socials:
                  </div>
                  <div className="profile-resume-user-info-name d-flex ">
                    <div className="profile-resume-user-info-items-cont  d-flex justify-content-center me-2">
                      <div className="profile-resume-social-items mt-2">
                        <img src={facebook} alt="" srcset="" />
                      </div>
                    </div>

                    <div className="profile-resume-user-info-items-cont  d-flex justify-content-center me-2">
                      <div className="profile-resume-social-items linkedIn-image mt-1">
                        <img src={linkedIn} alt="" srcset="" />
                      </div>
                    </div>
                    <div className="profile-resume-user-info-items-cont  d-flex justify-content-center me-2">
                      <div className="profile-resume-social-items githubImage mt-1">
                        <img src={github} alt="" srcset="" />
                      </div>
                    </div>
                    <div className="profile-resume-user-info-items-cont  d-flex justify-content-center me-2">
                      <div className="profile-resume-social-items pintrestImage mt-1">
                        <img src={pintrest} alt="" srcset="" />
                      </div>
                    </div>
                    <div className="profile-resume-user-info-items-cont  d-flex justify-content-center me-2">
                      <div className="profile-resume-social-items instaImage mt-1">
                        <img src={insta} alt="" srcset="" />
                      </div>
                    </div>
                    <div className="profile-resume-user-info-items-cont  d-flex justify-content-center">
                      <div className="profile-resume-social-items youtubeImage mt-1">
                        <img src={youtube} alt="" srcset="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="cv-form-details po-sticky job-sg single-stick email-cv-form-details profile-resume-userinfo ">
                <ul className="list-infor email-list-infor">
                  {/* <li>
                    <div className="category Notification-Text"> Career Finding
                    </div>
                    <div className="detail">
                      UI UX Designer
                    </div>
                  </li> */}
                  {userData.cityName == null ? "" : (
                    <li className='only-for-email'>
                    <div className="category Notification-Text">Location</div>
                    <div className="detail">
                      {userData.cityName}
                    </div>
                  </li>
                  )}
                  
                  {/* <li>
                    <div className="category Notification-Text"> Phone Number
                    </div>
                    <div className="detail">123 456 7890{" "}</div>
                  </li>
                  <li className="only-for-email">
                    <div className="category Notification-Text">Email</div>
                    <div className="detail"> hi.avitex@gmail.com</div>
                  </li>
                  <li>
                    <div className="category Notification-Text">Experience time</div>
                    <div className="detail"> 5 Years</div>
                  </li>
                  <li>
                    <div className="category Notification-Text">Language</div>
                    <div className="detail"> English, Vietnamese{" "}</div>
                  </li>
                  <li>
                    <div className="category Notification-Text">Age</div>
                    <div className="detail">   26 Years Old</div>
                  </li>
                  <li>
                    <div className="category Notification-Text">Qualification</div>
                    <div className="detail">Master Degree</div>
                  </li> */}
                </ul>

                {/* <div className="wd-social d-flex aln-center">
                  <span>Socials:</span>
                  <ul className="list-social d-flex aln-center">
                    <li>
                      <Link to="#">
                        <i className="icon-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-linkedin2"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-pinterest"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-instagram1"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="icon-youtube"></i>
                      </Link>
                    </li>
                  </ul>
                </div> */}

              </div>
            </div>

            <div className="col-lg-8 Aboutme-Container-Profile">
              <div className="profile-resume-parent-cont p-4 rounded-4">
                <div className="profile-resume-about">
                  <div className="profile-resume-about-heading f-24 f-800 mb-3">
                    About me
                  </div>

                  <div className="profile-resume-about-info">
                    {/* <p className="f-16 f-400">
                      Are you a User Experience Designer with a track record of
                      delivering intuitive digital experiences that drive
                      results? Are you a strategic storyteller and systems
                      thinker who can concept and craft smart, world-class
                      campaigns across a variety of mediums?
                    </p>
                    <p className="f-16 f-400">
                      Deloitte's Green Dot Agency is looking to add a Lead User
                      Experience Designer to our experience design team. We want
                      a passionate creative who's inspired by new trends and
                      emerging technologies, and is able to integrate them into
                      memorable user experiences. A problem solver who is
                      entrepreneurial, collaborative, hungry, and humble; can
                      deliver beautifully designed, leading-edge experiences
                      under tight deadlines; and who has demonstrated proven
                      expertise.
                    </p> */}
                  </div>
                </div>

                {/* <div className="profile-resume-education">
                  <div className="profile-resume-about-heading f-24 f-800 mb-3">
                    Education
                  </div>
                  <div className="d-flex">
                    <div className="profile-resume-verticle-line me-4"></div>
                    <div>
                      <div className="profile-resume-education-details mb-3">
                        <div className="profile-resume-university f-14 f-700">
                          FPT University <span>2019 - 2021</span>
                        </div>
                        <div className="profile-resume-education-designation f-16 f-700">
                          Graphic Design
                        </div>
                        <div className="profile-resume-education-designation-info f-14 f-400">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis. Class aptent taciti sociosqu ad
                          litora torquent per conubia nostra, per inceptos
                          himenaeos.
                        </div>
                      </div>
                      <div className="profile-resume-education-details">
                        <div className="profile-resume-university f-14 f-700">
                          TB Course <span>2019 - 2021</span>
                        </div>
                        <div className="profile-resume-education-designation f-16 f-700">
                          UX Design
                        </div>
                        <div className="profile-resume-education-designation-info f-14 f-400">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nunc vulputate libero et velit interdum, ac
                          aliquet odio mattis. Class aptent taciti sociosqu ad
                          litora torquent per conubia nostra, per inceptos
                          himenaeos.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="profile-resume-user-acvtivity mt-4">
                  <div className="profile-resume-about-heading f-24 f-800 mb-3">
                    User Activity Timeline
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="profile-resume-applied-status me-2"></div>
                      <div className="profile-resume-applied-jobs f-16 f-700">
                        Applied to Jobs
                      </div>
                    </div>

                    <div className="profile-resume-user-activity-time f-14 f-400">
                      12 min ago
                    </div>
                  </div>

                  <div className="profile-resume-user-actvity-container mb-3">
                    <p className="f-14 f-400 mb-0">
                      Invoices have been paid to the company
                    </p>
                    <div className="profile-resume-pdf-cont d-flex">
                      <div className="profile-resume-pdf-icon me-3">
                        <img src={Pdf} alt="" srcset="" />
                      </div>
                      <div className="profile-resume-pdf-text f-14 f-700">
                        CV_ TONY.pdf
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="profile-resume-applied-status me-2 profile-resume-success-icon"></div>
                      <div className="profile-resume-applied-jobs f-16 f-700">
                        Meeting with john
                      </div>
                    </div>
                    <div className="profile-resume-user-activity-time f-14 f-400">
                      45 min ago
                    </div>
                  </div>

                  <div className="profile-resume-user-actvity-container">
                    <p className="f-14 f-400 mb-0">
                      Interview meeting with john @10:15am
                    </p>
                    <div className="profile-resume-pdf-cont d-flex">
                      <div className="profile-resume-pdf-icon me-3">
                        <img src={Client} alt="" srcset="" />
                      </div>
                      <div>
                        <div className="profile-resume-pdf-text f-14 f-700">
                          John Doe (Client)
                        </div>
                        <p>Interview meeting with john @10:15am</p>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="profile-resume-applied-status me-2 profile-resume-cv-icon"></div>
                      <div className="profile-resume-applied-jobs f-16 f-700">
                        Upload CV
                      </div>
                    </div>

                    <div className="profile-resume-user-activity-time f-14 f-400">
                      5 day ago
                    </div>
                  </div>
                  <div className="profile-resume-user-actvity-container">
                    <p className="f-14 f-400">
                      Interview meeting with john @10:15am
                    </p>
                  </div>
                </div> */}
              </div>

            </div>
          </div>

          {/* <AppliedSec title="Job Applied Recently" /> */}

        </div>
      </div>
    </>
  );
};

export default UserResume;
